import POST_BV_FEEDBACK from '../../actionTypes/bazaarVoiceFeedbackActionTypes'

const postBVFeedback = payload => ({
  type: POST_BV_FEEDBACK,
  payload
})

export default postBVFeedback
